import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { isOperatingContextReady, useOperatingContext } from '../utils/operatingContextLifecycle';
import { useOperatingContextActions } from './OperatingContextProvider';

const OperatingContextGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = useAppSelector(state => state.auth.token);
  const context = useOperatingContext();
  const { retry } = useOperatingContextActions();
  if (isOperatingContextReady(context, token)) {
    return <React.Fragment key={context.generation}>{children}</React.Fragment>;
  }
  return <main className="page-shell">
    {context.status === 'error' ? <>
      <p role="alert">{context.error}</p>
      <button type="button" onClick={retry}>Повторити завантаження контексту</button>
    </> : context.token === token && context.status === 'missing'
      ? <p role="status">Оберіть робочу операційну групу у верхній панелі, щоб продовжити.</p>
      : <p role="status">Підтвердження операційного контексту…</p>}
    <Link to="/operating-contexts">Керувати контекстом роботи</Link>
  </main>;
};

export default OperatingContextGate;
